import {FC} from 'react';
import {Link} from 'react-router-dom';

import {Crumb} from './breadcrumbTrail';

/**
 * Onde a pessoa está, numa linha. O último nível em destaque e sem link; os
 * anteriores são links discretos. Nome longo trunca (o `title` tem o nome
 * inteiro) e, com pouca largura, os níveis do meio encolhem antes do último.
 * Não é título de página (`h1`): o título grande é o da tela.
 */
const Breadcrumb: FC<{trail: Crumb[]}> = ({trail}) => (
  <nav className='opx-crumbs' aria-label='Você está em'>
    <ol className='opx-crumbs__list'>
      {trail.map((crumb, index) => {
        const isLast = index === trail.length - 1;
        const position = isLast
          ? 'is-last'
          : index === 0
          ? 'is-first'
          : 'is-middle';
        return (
          <li
            key={`${index}-${crumb.path || crumb.title}`}
            className={`opx-crumbs__item ${position}`}
          >
            {index > 0 && (
              <span className='opx-crumbs__sep' aria-hidden='true'>
                /
              </span>
            )}
            {crumb.loading ? (
              <span className='opx-crumbs__loading'>
                <span
                  className='opx-skel opx-crumbs__skel'
                  aria-hidden='true'
                />
                <span className='visually-hidden'>Carregando</span>
              </span>
            ) : crumb.path && !isLast ? (
              <Link
                className='opx-crumbs__link'
                to={crumb.path}
                title={crumb.title}
              >
                {crumb.title}
              </Link>
            ) : (
              <span
                className={isLast ? 'opx-crumbs__current' : 'opx-crumbs__text'}
                aria-current={isLast ? 'page' : undefined}
                title={crumb.title}
              >
                {crumb.title}
              </span>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumb;
